// Web components to be bundled and included on legacy rails pages for use
//
// See also:
//  - frontend/entryPoints.mjs
//  - app/views/layouts/legacy/_head.haml
import('./react-component');
